export const reducerTypes = {
  LOADING: "reducer/LOADING",
  LOGIN: "reducer/LOGIN",
  LOGOUT: "reducer/LOGOUT",
};

export const sagaTypes = {
  LOGIN: "saga/LOGIN",
  LOGOUT: "saga/LOGOUT",
};
